export default {
  methods: {
    sendTD(options) {
      //插码
      let tdInfo;
      if (options.tdInfo) {
        tdInfo = options.tdInfo;
      } else {
        tdInfo = sessionStorage.getItem("tdInfo");
        tdInfo = tdInfo && JSON.parse(tdInfo);
      }
      if (window.TDAPP) {
        window.TDAPP.onEvent(options.eventId, options.label || "", {
          // ...this.$store.state.tdInfo,
          ...tdInfo,
          ...options.extra
        });
      }
    }
  }
};
